/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CheckFilters = {
  metadataReason?: Array<TaskMetadataReason> | null | undefined;
  priority?: Array<number> | null | undefined;
  type?: Array<TaskType> | null | undefined;
};

export type CheckStatus =
  "CANCELED" | "DONE" | "IN_PROGRESS" | "OPEN" | "SKIPPED" | "UNFULFILLABLE";

export type CreateCheckInput = {
  metadataReason: TaskMetadataReason;
  priority: number;
  shelfNumber: string;
  sku: string;
  type: TaskType;
};

export type TaskMetadataReason =
  | "BBD"
  | "BBD_MISSING"
  | "DROPPING"
  | "EOY_INVENTORY"
  | "EOY_INVENTORY_RECOUNT"
  | "EXPENSIVE"
  | "EXTRA"
  | "FRESHNESS"
  | "INVENTORY_DISCREPANCY"
  | "LOW_STOCK"
  | "MISSING"
  | "ROLLING_8_WEEKS"
  | "ROLLING_12_WEEKS"
  | "ROLLING_INVENTORY"
  | "SPONTANEOUS_CORRECTION"
  | "TOBACCO";

export type TaskType =
  | "BBD_CHECK"
  | "EOY_INVENTORY_CHECK"
  | "EOY_INVENTORY_RECOUNT_CHECK"
  | "FRESHNESS_CHECK"
  | "INVENTORY_DISCREPANCY_CHECK"
  | "STOCK_CHECK";

export type GetCheckByIdQueryVariables = Exact<{
  checkId: string | number;
  isAlwaysInbound?: boolean | null | undefined;
}>;

export type GetCheckByIdQuery = {
  getTaskById: {
    task: {
      id: string;
      priority: number;
      productSku: string;
      shelfNumber: string;
      status: Types.CheckStatus;
      type: Types.TaskType;
      product: {
        imageUrl: string | null;
        minDaysToBestBeforeDate: number | null;
        name: string;
        sku: string;
        countryOfOrigin: { code: string | null };
      } | null;
      customAttributes: {
        desadv: string | null;
        sscc: string | null;
        expectedQuantity: number | null;
      } | null;
    } | null;
  };
};

export type GetNextCheckForHubQueryVariables = Exact<{ [key: string]: never }>;

export type GetNextCheckForHubQuery = {
  getNextCheckForHub: {
    check: {
      id: string;
      priority: number;
      shelfNumber: string;
      status: Types.CheckStatus;
      type: Types.TaskType;
      product: {
        imageUrl: string | null;
        name: string;
        sku: string;
        countryOfOrigin: { code: string | null };
      } | null;
      customAttributes: {
        desadv: string | null;
        sscc: string | null;
        expectedQuantity: number | null;
      } | null;
    } | null;
  };
};

export type GetPendingChecksQueryVariables = Exact<{
  input?: Types.CheckFilters | null | undefined;
}>;

export type GetPendingChecksQuery = {
  getPendingChecks: {
    checks: Array<{
      id: string;
      priority: number;
      shelfNumber: string;
      type: Types.TaskType;
      customAttributes: {
        desadv: string | null;
        sscc: string | null;
        expectedQuantity: number | null;
      } | null;
    }>;
  };
};

export type GetNextCheckForShelfQueryVariables = Exact<{
  shelfNumber: string;
  filters?: Types.CheckFilters | null | undefined;
  isAlwaysInbound?: boolean | null | undefined;
}>;

export type GetNextCheckForShelfQuery = {
  getNextCheckForShelf: {
    check: {
      id: string;
      priority: number;
      productSku: string;
      shelfNumber: string;
      status: Types.CheckStatus;
      type: Types.TaskType;
      product: {
        name: string;
        imageUrl: string | null;
        sku: string;
        countryOfOrigin: { code: string | null };
      } | null;
      customAttributes: {
        desadv: string | null;
        sscc: string | null;
        expectedQuantity: number | null;
      } | null;
    } | null;
  };
};

export type CreateCheckMutationVariables = Exact<{
  input: Types.CreateCheckInput;
}>;

export type CreateCheckMutation = { createCheck: { success: boolean } };

export type StartCheckMutationVariables = Exact<{
  checkId: string | number;
}>;

export type StartCheckMutation = { startCheck: { success: boolean } };

export const GetCheckByIdDocument = gql`
  query GetCheckById($checkId: ID!, $isAlwaysInbound: Boolean) {
    getTaskById(input: { taskId: $checkId }) {
      task {
        id
        priority
        productSku
        shelfNumber
        status
        type
        product(isAlwaysInbound: $isAlwaysInbound) {
          imageUrl
          minDaysToBestBeforeDate
          name
          sku
          countryOfOrigin {
            code
          }
        }
        customAttributes {
          desadv
          sscc
          expectedQuantity
        }
      }
    }
  }
`;

/**
 * __useGetCheckByIdQuery__
 *
 * To run a query within a React component, call `useGetCheckByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckByIdQuery({
 *   variables: {
 *      checkId: // value for 'checkId'
 *      isAlwaysInbound: // value for 'isAlwaysInbound'
 *   },
 * });
 */
export function useGetCheckByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetCheckByIdQuery, GetCheckByIdQueryVariables> &
    ({ variables: GetCheckByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCheckByIdQuery, GetCheckByIdQueryVariables>(
    GetCheckByIdDocument,
    options,
  );
}
export function useGetCheckByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCheckByIdQuery, GetCheckByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCheckByIdQuery, GetCheckByIdQueryVariables>(
    GetCheckByIdDocument,
    options,
  );
}
// @ts-ignore
export function useGetCheckByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetCheckByIdQuery, GetCheckByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCheckByIdQuery, GetCheckByIdQueryVariables>;
export function useGetCheckByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCheckByIdQuery, GetCheckByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCheckByIdQuery | undefined, GetCheckByIdQueryVariables>;
export function useGetCheckByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCheckByIdQuery, GetCheckByIdQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCheckByIdQuery, GetCheckByIdQueryVariables>(
    GetCheckByIdDocument,
    options,
  );
}
export type GetCheckByIdQueryHookResult = ReturnType<typeof useGetCheckByIdQuery>;
export type GetCheckByIdLazyQueryHookResult = ReturnType<typeof useGetCheckByIdLazyQuery>;
export type GetCheckByIdSuspenseQueryHookResult = ReturnType<typeof useGetCheckByIdSuspenseQuery>;
export type GetCheckByIdQueryResult = Apollo.QueryResult<
  GetCheckByIdQuery,
  GetCheckByIdQueryVariables
>;
export const GetNextCheckForHubDocument = gql`
  query GetNextCheckForHub {
    getNextCheckForHub {
      check {
        id
        priority
        shelfNumber
        status
        type
        product {
          imageUrl
          name
          sku
          countryOfOrigin {
            code
          }
        }
        customAttributes {
          desadv
          sscc
          expectedQuantity
        }
      }
    }
  }
`;

/**
 * __useGetNextCheckForHubQuery__
 *
 * To run a query within a React component, call `useGetNextCheckForHubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextCheckForHubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextCheckForHubQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNextCheckForHubQuery(
  baseOptions?: Apollo.QueryHookOptions<GetNextCheckForHubQuery, GetNextCheckForHubQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetNextCheckForHubQuery, GetNextCheckForHubQueryVariables>(
    GetNextCheckForHubDocument,
    options,
  );
}
export function useGetNextCheckForHubLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNextCheckForHubQuery,
    GetNextCheckForHubQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetNextCheckForHubQuery, GetNextCheckForHubQueryVariables>(
    GetNextCheckForHubDocument,
    options,
  );
}
// @ts-ignore
export function useGetNextCheckForHubSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetNextCheckForHubQuery,
    GetNextCheckForHubQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetNextCheckForHubQuery, GetNextCheckForHubQueryVariables>;
export function useGetNextCheckForHubSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetNextCheckForHubQuery, GetNextCheckForHubQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetNextCheckForHubQuery | undefined,
  GetNextCheckForHubQueryVariables
>;
export function useGetNextCheckForHubSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetNextCheckForHubQuery, GetNextCheckForHubQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetNextCheckForHubQuery, GetNextCheckForHubQueryVariables>(
    GetNextCheckForHubDocument,
    options,
  );
}
export type GetNextCheckForHubQueryHookResult = ReturnType<typeof useGetNextCheckForHubQuery>;
export type GetNextCheckForHubLazyQueryHookResult = ReturnType<
  typeof useGetNextCheckForHubLazyQuery
>;
export type GetNextCheckForHubSuspenseQueryHookResult = ReturnType<
  typeof useGetNextCheckForHubSuspenseQuery
>;
export type GetNextCheckForHubQueryResult = Apollo.QueryResult<
  GetNextCheckForHubQuery,
  GetNextCheckForHubQueryVariables
>;
export const GetPendingChecksDocument = gql`
  query GetPendingChecks($input: CheckFilters) {
    getPendingChecks(input: $input) {
      checks {
        id
        priority
        shelfNumber
        type
        customAttributes {
          desadv
          sscc
          expectedQuantity
        }
      }
    }
  }
`;

/**
 * __useGetPendingChecksQuery__
 *
 * To run a query within a React component, call `useGetPendingChecksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingChecksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingChecksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPendingChecksQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPendingChecksQuery, GetPendingChecksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPendingChecksQuery, GetPendingChecksQueryVariables>(
    GetPendingChecksDocument,
    options,
  );
}
export function useGetPendingChecksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPendingChecksQuery, GetPendingChecksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPendingChecksQuery, GetPendingChecksQueryVariables>(
    GetPendingChecksDocument,
    options,
  );
}
// @ts-ignore
export function useGetPendingChecksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPendingChecksQuery,
    GetPendingChecksQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetPendingChecksQuery, GetPendingChecksQueryVariables>;
export function useGetPendingChecksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPendingChecksQuery, GetPendingChecksQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetPendingChecksQuery | undefined, GetPendingChecksQueryVariables>;
export function useGetPendingChecksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPendingChecksQuery, GetPendingChecksQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPendingChecksQuery, GetPendingChecksQueryVariables>(
    GetPendingChecksDocument,
    options,
  );
}
export type GetPendingChecksQueryHookResult = ReturnType<typeof useGetPendingChecksQuery>;
export type GetPendingChecksLazyQueryHookResult = ReturnType<typeof useGetPendingChecksLazyQuery>;
export type GetPendingChecksSuspenseQueryHookResult = ReturnType<
  typeof useGetPendingChecksSuspenseQuery
>;
export type GetPendingChecksQueryResult = Apollo.QueryResult<
  GetPendingChecksQuery,
  GetPendingChecksQueryVariables
>;
export const GetNextCheckForShelfDocument = gql`
  query GetNextCheckForShelf(
    $shelfNumber: String!
    $filters: CheckFilters
    $isAlwaysInbound: Boolean
  ) {
    getNextCheckForShelf(input: { shelfNumber: $shelfNumber, filters: $filters }) {
      check {
        id
        priority
        productSku
        shelfNumber
        status
        type
        product(isAlwaysInbound: $isAlwaysInbound) {
          name
          imageUrl
          sku
          countryOfOrigin {
            code
          }
        }
        customAttributes {
          desadv
          sscc
          expectedQuantity
        }
      }
    }
  }
`;

/**
 * __useGetNextCheckForShelfQuery__
 *
 * To run a query within a React component, call `useGetNextCheckForShelfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextCheckForShelfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextCheckForShelfQuery({
 *   variables: {
 *      shelfNumber: // value for 'shelfNumber'
 *      filters: // value for 'filters'
 *      isAlwaysInbound: // value for 'isAlwaysInbound'
 *   },
 * });
 */
export function useGetNextCheckForShelfQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetNextCheckForShelfQuery,
    GetNextCheckForShelfQueryVariables
  > &
    ({ variables: GetNextCheckForShelfQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetNextCheckForShelfQuery, GetNextCheckForShelfQueryVariables>(
    GetNextCheckForShelfDocument,
    options,
  );
}
export function useGetNextCheckForShelfLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNextCheckForShelfQuery,
    GetNextCheckForShelfQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetNextCheckForShelfQuery, GetNextCheckForShelfQueryVariables>(
    GetNextCheckForShelfDocument,
    options,
  );
}
// @ts-ignore
export function useGetNextCheckForShelfSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetNextCheckForShelfQuery,
    GetNextCheckForShelfQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetNextCheckForShelfQuery, GetNextCheckForShelfQueryVariables>;
export function useGetNextCheckForShelfSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetNextCheckForShelfQuery,
        GetNextCheckForShelfQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetNextCheckForShelfQuery | undefined,
  GetNextCheckForShelfQueryVariables
>;
export function useGetNextCheckForShelfSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetNextCheckForShelfQuery,
        GetNextCheckForShelfQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetNextCheckForShelfQuery, GetNextCheckForShelfQueryVariables>(
    GetNextCheckForShelfDocument,
    options,
  );
}
export type GetNextCheckForShelfQueryHookResult = ReturnType<typeof useGetNextCheckForShelfQuery>;
export type GetNextCheckForShelfLazyQueryHookResult = ReturnType<
  typeof useGetNextCheckForShelfLazyQuery
>;
export type GetNextCheckForShelfSuspenseQueryHookResult = ReturnType<
  typeof useGetNextCheckForShelfSuspenseQuery
>;
export type GetNextCheckForShelfQueryResult = Apollo.QueryResult<
  GetNextCheckForShelfQuery,
  GetNextCheckForShelfQueryVariables
>;
export const CreateCheckDocument = gql`
  mutation CreateCheck($input: CreateCheckInput!) {
    createCheck(input: $input) {
      success
    }
  }
`;
export type CreateCheckMutationFn = Apollo.MutationFunction<
  CreateCheckMutation,
  CreateCheckMutationVariables
>;

/**
 * __useCreateCheckMutation__
 *
 * To run a mutation, you first call `useCreateCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckMutation, { data, loading, error }] = useCreateCheckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCheckMutation, CreateCheckMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCheckMutation, CreateCheckMutationVariables>(
    CreateCheckDocument,
    options,
  );
}
export type CreateCheckMutationHookResult = ReturnType<typeof useCreateCheckMutation>;
export type CreateCheckMutationResult = Apollo.MutationResult<CreateCheckMutation>;
export type CreateCheckMutationOptions = Apollo.BaseMutationOptions<
  CreateCheckMutation,
  CreateCheckMutationVariables
>;
export const StartCheckDocument = gql`
  mutation StartCheck($checkId: ID!) {
    startCheck(input: { checkId: $checkId }) {
      success
    }
  }
`;
export type StartCheckMutationFn = Apollo.MutationFunction<
  StartCheckMutation,
  StartCheckMutationVariables
>;

/**
 * __useStartCheckMutation__
 *
 * To run a mutation, you first call `useStartCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCheckMutation, { data, loading, error }] = useStartCheckMutation({
 *   variables: {
 *      checkId: // value for 'checkId'
 *   },
 * });
 */
export function useStartCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<StartCheckMutation, StartCheckMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartCheckMutation, StartCheckMutationVariables>(
    StartCheckDocument,
    options,
  );
}
export type StartCheckMutationHookResult = ReturnType<typeof useStartCheckMutation>;
export type StartCheckMutationResult = Apollo.MutationResult<StartCheckMutation>;
export type StartCheckMutationOptions = Apollo.BaseMutationOptions<
  StartCheckMutation,
  StartCheckMutationVariables
>;
